export const outboundRoutes = [
  {
    path: "/outbound/shipment/:id/scan",
    name: "outbound.shipment.scan.index",
    component: () =>
      import("@/views/outbound/shipment/OutboundShipmentScanPage.vue"),
    meta: {
      title: "Outbound Shipment Scan",
      ability: { action: "create", subject: "Outbound" },
    },
  },
  {
    path: "/outbound/shipment/:id/details/",
    name: "outbound.shipment.details.index",
    component: () =>
      import("@/views/outbound/shipment/OutboundShipmentDetailsPage.vue"),
    meta: {
      title: "Outbound Shipment Details",
      ability: { action: "read", subject: "Outbound" },
    },
  },
  {
    path: "/outbound/shipment/:id/summary",
    name: "outbound.shipment.summary.index",
    props: true,
    component: () =>
      import("@/views/outbound/shipment/OutboundShipmentSummaryPage.vue"),
    meta: {
      title: "Outbound Shipment Summary",
      ability: { action: "create", subject: "Outbound" },
    },
  },
];
